import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import FactorySelector from "components/shared/FactorySelector";
import { useState } from "react";
import { CREATE_ASSESSMENT } from "./graphql";

const CreateAssessmentView = ({ complete }) => {
  const [supplierId, setSupplierId] = useState(null);
  const [portalSupplierId, setPortalSupplierId] = useState(null);
  const [createAssessment, createAssessmentRes] = useMutation(
    CREATE_ASSESSMENT,
    {
      variables: { supplierId, portalSupplierId },
      onCompleted: (data) => {
        complete(data.createAssessment.assessment);
        Alert("success", "Assessment created");
      },
      onError: (error) => {
        Alert("error", parseError(error));
      },
      refetchQueries: ["FETCH_ASSESSMENTS"],
    },
  );

  return (
    <div>
      <div>
        <div className="flex items-center space-x-3">
          <label htmlFor="">Supplier: </label>
          <FactorySelector
            value={supplierId}
            onChange={(id) => {
              setSupplierId(id);
              setPortalSupplierId(id);
            }}
          />
        </div>
        <div className="text-sm text-gray-700">
          The supplier for the assessment. Use in most cases in our system,
          including purchase, inventory, production capacity, analytics, etc.
        </div>
      </div>

      <div>
        <div className="flex items-center space-x-3 mt-4">
          <label htmlFor="">Portal Supplier: </label>
          <FactorySelector
            value={portalSupplierId}
            onChange={setPortalSupplierId}
          />
        </div>
        <div className="text-sm text-gray-700">
          The supplier who will login to Supplier Portal and do the assessment.
          This is designed for a special case: Little Land and Xufeng. Little
          land will do both assessment for themselves and an assessment for
          Xufeng.
        </div>
      </div>

      <div className="opacity-70 mt-4 text-sm">
        You create an assessment for a supplier. You start the assessment after
        creation. You can set a due date for the assessment. By default we use
        the <b>latest assessment questions</b> we created. If you need to update
        the questions, you should contact Charlie.
      </div>

      <div className="mt-10">
        <Button
          className="text-sm"
          primary
          next
          onClick={createAssessment}
          loading={createAssessmentRes.loading}
          disabled={!supplierId || !portalSupplierId}
        >
          Create Now
        </Button>
      </div>
    </div>
  );
};

export default CreateAssessmentView;
